import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { blogs } from "../../../constants/blogs.constant";

type Props = {};

const SiteBlogItemComponent = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 tw-px-1">
      <Col className="p-0">
        <Row className="m-0">
          <Col className="p-0">
            <Row className="tw-mt-5 mx-0">
              <Col className="tw-flex tw-justify-start p-0 md:tw-flex-nowrap tw tw-flex-wrap">
                {blogs.map((blog, index) => (
                  <div key={blog.id}>
                    <Link to={`blog/${blog.id}`}>
                      <Row className="m-0">
                        <Col className="p-1">
                          <Row className="p-0 mx-0">
                            <Col className="p-md-1 p-0">
                              <img
                                loading="lazy"
                                crossOrigin="anonymous"
                                src={blog.picture}
                                className="w-100 h-100 tw-rounded-lg object-fit-contain"
                              />
                            </Col>
                          </Row>
                          <Row className="tw-mt-3 mx-0">
                            <Col className="px-2">
                              <h3 className="font-sofiaSans tw-font-extrabold tw-leading-6">
                                {t(blog.title)}
                              </h3>
                            </Col>
                          </Row>
                          <Row className="mx-0">
                            <Col className="d-flex p-0 gap-2 align-items-center">
                              {blog.tags?.map((tag, i) => (
                                <Button key={i} variant="secondary" size="sm">
                                  {t("home/SiteBlogItem/btn")}
                                </Button>
                              ))}

                              {blog.createDate && (
                                <span className="fs-5 color-forthColor font-sofiaSans fw-bold">
                                  {blog.createDate}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Link>
                  </div>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SiteBlogItemComponent;
